/**
 * Component Registry for NOVO Sweetwater
 * 
 * Inherits from @vibesites-axia-residential-arc-living/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-axia-residential-arc-living/theme-preferred/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PreferredEmployerProgram } from './components/PreferredEmployerProgram';
import { ScheduleATour } from './components/ScheduleATour';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Nav merges base + company + property pages.json so Preferred Employer
  // Program (added at company level, enabled here) appears in the menu.
  Header,
  // Home hero plays the property video as a full-bleed background.
  Hero,
  // Preferred Employer Program: waived app + admin fees for NOVO Sweetwater employers.
  PreferredEmployerProgram,
  // Schedule A Tour renders info-only (address, phone, office hours).
  // The inline tour-scheduler form is removed — tour scheduling is handled
  // by the iframe block above this section.
  ScheduleATour,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
